import React, { Component } from 'react'
import "./App.css";
import 'bootstrap/dist/css/bootstrap.css';
import Nav from './components/Nav/Nav';
import ToastPanel from './components/Toasts/ToastPanel';
import { Container, Row, Col } from 'reactstrap';
import AuthenticationButton from './components/AuthenticationButton/AuthenticationButton';


class App extends Component {

    constructor(props) {
        super(props);

        this.path = String(window.location.pathname).split('/');
        this.path.splice(0, 1);

        if (!localStorage.getItem('clientId')) localStorage.setItem('clientId', 'PPE_CSSI_Test');

        this.state = {
            user: null,
            clients: [],
            clientName: null,
            userPermissions: [],
            userClients: [],
            error: false,
            clientId: localStorage.getItem('clientId')
        }

        this.viewAppLogs = false;
        this.viewInfoLogs = false;
        this.toastCallback = false;

        this.schema = {
            parents: [
                {
                    name: 'Company Info', headers: ['Tran Type', 'PE Status', 'PE Type'], sections: [
                        {
                            name: 'Company Info', stateSection: 'address', limit: 1, fields: [
                                {
                                    hint: 'Firm Address', name: 'firmAddress', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Firm City', name: 'firmCity', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Firm State', name: 'firmState', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Firm Zip', name: 'firmZip', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Phone Number', name: 'phoneNumber', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Contact', name: 'contact', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Website', name: 'website', col: 4, type: 'text', classNames: '', validation: '', inputMask: '',
                                },
                                {
                                    hint: 'Notes', name: 'notes', col: 4, type: 'textarea', classNames: '', validation: '', inputMask: '',
                                },
                            ]
                        },
                        {
                            name: 'Tran Type/PE', stateSection: 'companyInfo', limit: 1, fields: [
                                {
                                    hint: 'Tran Type', name: 'tranType', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['Buy', 'Sell', 'Dividend', 'Pre-Funding', 'Commitment', 'Transfer In', 'Transfer Out',
                                        'Capital Call', 'Late Interest', 'Interest', 'Return of Capital', 'Return of Callable Capital', 'Fund Valuation']
                                },
                                {
                                    hint: 'PE Status', name: 'peStatus', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['Pending', 'Long', 'Short']
                                },
                                {
                                    hint: 'PE Type', name: 'peType', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['Credit', 'Absolute Return', 'Hedged Equities', 'Global Equities', 'Inflation Linked Bonds', 'Commodities', 'Cash']
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'Benchmarks', headers: ['Benchmark 1', 'Benchmark 1 Identifier', 'Benchmark 2', 'Benchmark 2 Identifier',
                        'Benchmark 3', 'Benchmark 3 Identifier', 'Benchmark 4', 'Benchmark 4 Identifier'], sections: [
                            {
                                name: 'Benchmarks', stateSection: 'benchmarks', limit: 1, fields: [
                                    {
                                        hint: 'Benchmark 1', name: 'benchmark1', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['HFRI FOF: Conservative Index', 'HFRI FOF: Strategic Index', 'S&P GSCI TR']
                                    },
                                    { hint: 'Benchmark 1 Identifier', name: 'benchmark1id', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    {
                                        hint: 'Benchmark 2', name: 'benchmark2', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['HFRI FOF: Conservative Index', 'HFRI FOF: Strategic Index', 'S&P GSCI TR']
                                    },
                                    { hint: 'Benchmark 2 Identifier', name: 'benchmark2id', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    {
                                        hint: 'Benchmark 3', name: 'benchmark3', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['HFRI FOF: Conservative Index', 'HFRI FOF: Strategic Index', 'S&P GSCI TR']
                                    },
                                    { hint: 'Benchmark 3 Identifier', name: 'benchmark3id', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    {
                                        hint: 'Benchmark 4', name: 'benchmark4', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['HFRI FOF: Conservative Index', 'HFRI FOF: Strategic Index', 'S&P GSCI TR']
                                    },
                                    { hint: 'Benchmark 4 Identifier', name: 'benchmark4id', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                ]
                            },
                        ]
                },
                {
                    name: 'Currency', headers: ['Currency'], sections: [
                        {
                            name: 'Currency', stateSection: 'currency', limit: 1, fields: [
                                {
                                    hint: 'Currency', name: 'currency', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['USD - US Dollar', 'EUR - Euro Dollar', 'GBD - British Pound']
                                },
                            ]
                        },
                    ]
                },
            ]
        }
    }

    componentDidMount = () => {
        this.log('App.js/componentDidMount');
        this.onChangeClient(this.state.clientId, () => {
            this.refreshUser();
        });
    }

    onChangeClient = (clientId, cb) => {
        localStorage.setItem('clientId', clientId)
        this.setState({
            clientId: clientId
        }, () => {
            fetch('/api/clients/switch', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify({
                    clientId: clientId
                })
            })
                .then(response => {
                    if (response.ok) { // Check if the response status is in the range of 200-299
                        console.log('Switched!');
                        if (cb) cb();
                    } else {
                        if (this.props.addToast) this.props.addToast('Client switch failed.', 5, 'danger');
                    }
                })
                .catch(() => {
                    if (this.props.addToast) this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    }

    checkPermission = (permission) => {
        this.info('EmployeesContainer.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.state.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    log = (...args) => {
        if (!this.viewAppLogs) return;
        const colors = ['#BADA55', '#F5B7B1', '#F5CBA7', '#F9E79F', '#ABEBC6', '#A3E4D7', '#AED6F1', '#D7BDE2']
        const method = args.shift();
        const page = method.split('/')[0];
        let color = '';
        switch (page) {
            // case "Home.js": color = colors[3]; break;
            default: color = colors[0];
        }
        console.log('%c' + method + '\n', 'font-weight: bold; color: ' + color + ';', ...args)
    }

    info = (...args) => {
        if (!this.viewInfoLogs) return;
        const colors = ['#888888', '#F5CBA7', '#F9E79F', '#ABEBC6', '#A3E4D7', '#AED6F1', '#D7BDE2']
        const method = args.shift();
        const page = method.split('/')[0];
        let color = '';
        switch (page) {
            // case "Home.js": color = colors[3]; break;
            default: color = colors[0];
        }
        console.log('%c' + method + '\n', 'font-weight: bold; color: ' + color + ';', ...args)
    }

    addToast = (str, delay, color) => {
        this.log('App.js/addToast (str,delay,color)', str, delay, color)
        if (this.toastCallback != null && typeof (this.toastCallback) === 'function') this.toastCallback({
            str: str,
            delay: (delay != null ? delay : 5),
            color: (color != null ? color : 'primary'),
            timestamp: new Date()
        })
    }

    addCallback = (cb) => {
        this.log('App.js/addCallback (cb)', cb)
        this.toastCallback = cb;
    }

    isJSON = (str) => {
        this.log('App.js/isJSON (str)', str)
        if (str === '' || str == null || str === undefined || str.length < 2) return false;
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    isFieldNull = (val, checkbox) => {
        this.info('App.js/isFieldNull (val, checkbox)', val, checkbox);
        return (val != null) ? val : ((checkbox != null && checkbox) ? false : '');
    }


    refreshUser = () => {
        this.log('App.js/refreshUser')
        fetch('/api/users/' + this.props.auth0, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.state.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {

                    this.setState({
                        user: this.props.auth0,
                        userPermissions: results.data.permissions,
                        userAppAuthenticated: true
                    }, () => {
                        this.viewAppLogs = this.checkPermission('View App Logs');
                        this.viewInfoLogs = this.checkPermission('View Info Logs');
                    });
                } else {
                    this.setState({
                        error: true,
                    });
                    this.addToast('Unable to authenticate user.', 0, 'danger');
                }
            })
    }

    ping = () => {
        this.log('App.js/ping')
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 2500)

        fetch('/ping', {
            signal: controller.signal,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                clearTimeout(timeoutId);
            })
            .catch(() => {
                clearTimeout(timeoutId);
                this.addToast('Unable to reach server.', 2, 'danger');
            })
    }

    handleChangeClientToken = (token) => {
        this.log('App.js/handleChangeClientToken (token)', token)
        localStorage.setItem('clientToken', token);
        this.setState({
            clientToken: token,
            loadMappings: true
        }, () => this.init());
    }

    replaceSpecialChars = (str) => {
        this.info('App.js/replaceSpecialChars (str)', str)
        if (str == null) return '';
        return str.split('/').map(segment => {
            return segment.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
                .replaceAll('%2F', '-')
                .replace(/\//g, '-')
                .replaceAll('%20', ' ')
                .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
                .replace(/--+/g, '-')	// Replaces multiple hyphens by one hyphen
                .replace(/(^-+|-+$)/, ''); // Remove extra hyphens from beginning or end of the string
        }).join('/').toLowerCase();
    }

    render = () => {
        this.log('App.js/render');
        this.ping();
        return (
            <>{this.state.user != null /*&& this.state.clients.length > 0*/ ?
                <Nav
                    {...this.props}
                    user={this.state.user}
                    userPermissions={this.state.userPermissions}
                    userClients={this.state.userClients}
                    // clients={this.state.clients}
                    clientId={this.state.clientId}
                    // clientName={this.state.clientName}
                    refreshUser={this.refreshUser}
                    isJSON={this.isJSON}
                    isFieldNull={this.isFieldNull}
                    addToast={this.addToast}
                    isAuthenticated={true}
                    getClients={this.getClients}
                    log={this.log}
                    info={this.info}
                    ping={this.ping}
                    replaceSpecialChars={this.replaceSpecialChars}
                    onChangeClient={this.onChangeClient}
                    companySchema={this.schema}
                />
                :
                <>
                    <nav className="Nav">
                        <Container fluid>
                            <Row>
                                <Col className="text-right">
                                    <AuthenticationButton />
                                </Col>
                            </Row>
                        </Container>
                    </nav>
                    {this.state.error ? <h1>Application Error, please try again later.</h1> : <></>}
                </>}
                <div className="toastPanel align-bottom">
                    <ToastPanel
                        toastArray={this.state.toastArray}
                        addCallback={this.addCallback}
                        log={this.log}
                        info={this.info}
                    />
                </div>
            </>
        )
    }
}

export default App;